export default __webpack_public_path__ + "static/media/ROM EXAM PATTERN 2025 (CLASS - 6).ccaa5e81.pdf";